module.exports = __webpack_public_path__ + "img/j2.820528cc.webp";